// Same URL the app registers in serviceWorker.js, so this returns the existing root-scope registration instead of creating a competing one.
export const registerPushServiceWorker = () =>
  navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ""}/sw.js`, { scope: "/" });
